import { Content, ContentWrapper, HighStreetRetailShoppingWrapper, LeftImage, RightImage } from "./styles"
import { Heading } from "../../components/heading/Heading"
import { P } from "../../components/p/P"
import MomKid from './img/mom-kid.jpg'
import Couple from './img/couple.jpg'

export const HighStreetRetailShopping = () => {
    return (
        <HighStreetRetailShoppingWrapper>
            <Heading level={2}>High Street Retail Shopping</Heading>
            <P>Lucknow’s first high street shopping mall retail.</P>

            <ContentWrapper>
                <LeftImage src={Couple} alt='Shopping image' />
                <Content>High-street retail establishments are the new royals of the town. With Consumer pereferences shifting toward high-street retail stores, it's high time to upgrade from traditional malls to a high street retail mall.</Content>
                <RightImage src={MomKid} alt='Shopping image' />
            </ContentWrapper>
        </HighStreetRetailShoppingWrapper>
    )
}